export interface IUserCookie {
  name: string;
  value: string;
  expire: string;
  path: string;
  domain: string;
}

interface IRegisterResponse {
    id: number,
    email: string,
    token: string,
    cookies?: IUserCookie[]
}

export const instanceOfIRegisterResponse = (object: any) : object is IRegisterResponse => {
    return 'id' in object &&
            'email' in object &&
            'token' in object
}

export default IRegisterResponse